import React, { memo } from 'react';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { Typography } from '@surveycake/rc';
import { ColorResolver } from '@surveycake/rc';
import { RequiredStar } from 'app/pages/Survey/Subject/elements';
import { useStyles } from './styles';

const colorSelector: ColorResolver = theme => theme.survey.color.black;

function VisualNumber() {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const { vn, required } = engine.getSubjectData(id);
  const hasVn = Boolean(vn);
  const styles = useStyles([hasVn]);

  return (
    <div className={styles.vn} aria-label="subject visual number" data-vn={vn}>
      <div className={styles.vnInner}>
        {hasVn && (
          <Typography className={styles.transform} variant="div" color={colorSelector} weight="bold">
            {vn}
          </Typography>
        )}
        {required && <RequiredStar hasVn={hasVn} />}
      </div>
    </div>
  );
}

export default memo(VisualNumber);
